<template>
  <div class="page-container">
    <div class="query-title">编制计划总表</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { reportForm10 } from '@/api/sap/report'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/preparePlanReportForms'
import { frontExport, exportAll } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        sort: this.sortData.concat(this.tableSort)
      }
      // 如果点击查询，传入标识符，后端返回 过滤条件 和 计算数据
      if (ranges) {
        params.is_result = 1
      }
      this.loading = true
      try {
        const { data, total, calculation, field } = await reportForm10(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // // 导出全部 导出本页
    // async exportExcel(type) {
    //   if (!this.gridOptions.data.length) {
    //     await this.queryData()
    //   }
    //   // 导出本页
    //   if (type === 'page') {
    //     frontExport(this.gridOptions.columns, this.gridOptions.data, '经销商开票情况明细报表')
    //   } else {
    //     // 导出全部
    //     const params = {
    //       ...filterSapParams(this.conditions),
    //       user_bp: this.$store.getters.role.USER_BP,
    //       role: this.$store.getters.role.ROLE,
    //       ...this.pagination
    //     }
    //     const options = {
    //       columns: this.gridOptions.columns,
    //       resk: 'data',
    //       fileName: '经销商开票情况明细报表'
    //     }
    //     exportAll(reportForm1, params, options)
    //   }
    // },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report-forms-manage/preparePlanReportForms.vue